export default {
  lang: {
    choose: '语言/Language',
    zhcn: '简体中文',
    zhtw: '繁體中文(臺灣)',
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    de: 'Deutsch',
    sv: 'Svenska',
    ja: '日本語',
    changeok: '言語の切り替えに成功しました'
  },
  btn: {
    ok: 'OK',
    cancel: 'キャンセル',
    cont: '続行'
  },
  menu: {
    upload: 'アップロード',
    newfolder: '新しいフォルダ',
    del: '削除',
    up: '親フォルダ',
    refresh: '更新',
    dfu: 'DFU',
  },
  status: {
    connected: '接続済み、バージョン: ',
    version: 'バージョン:',
    mac: 'MACアドレス:',
    loading: '読み込み中…',
  },
  conn: {
    connect: '接続',
    connecting: '接続中…',
    disconnect: '切断…',
    consuccess: 'Pixl.js に正常に接続されました！',
    disconnected: 'Pixl.js が切断されました！',
    connfailed: 'Pixl.js の接続に失敗しました！'
  },
  labels: {
    name: '名前',
    size: 'サイズ',
    type: '種類',
    remark: '備考'
  },
  contxmenu: {
    del: '削除…',
    rename: '名前変更…',
    prop: 'プロパティ…',
    format: 'フォーマット…'
  },
  properties: {
    title: 'プロパティ',
    remark: '備考',
    entermsg: '備考を入力してください',
    attrib: '属性',
    hide: '非表示',
    readonly: '読み取り専用',
    errupdate: 'プロパティの更新に失敗しました！',
    remarktoolong: '備考は最大90バイトまでです（半角90文字、または全角30文字）。現在: ',
    remarktoolongend: ' バイト）'
  },
  upload: {
    title: 'アップロード',
    drag: 'ここにファイルをドラッグ、または ',
    click: 'クリックしてアップロード。',
    maxsize: 'ファイルパスの合計長は63バイトを超えられません。',
    maxname: 'ファイル名は47バイトを超えられません。',
    closetitle: '閉じてもよろしいですか？',
    closemessage: 'ダイアログを閉じるとアップロード履歴がクリアされ、アップロードキューは中断されます。',
    errupload: 'アップロード失敗: '
  },
  format: {
    title: 'フォーマット',
    messrow1a: 'フォーマットしますか ',
    messrow1b: '？',
    messrow2: 'フォーマットするとすべてのデータが削除されます！',
    messrow3: 'フォーマットには約10秒かかる場合があります。しばらくお待ちください。',
    formatok: 'フォーマットが完了しました！',
    formaterr: 'フォーマット失敗: '
  },
  del: {
    title: '削除',
    message: 'ファイルを削除します: ',
    messageend: '？',
    error: 'ファイルの削除に失敗しました: ',
    deleteok: 'ファイルを正常に削除しました！'
  },
  dfumode: {
    title: 'DFUモード',
    startconfirm: 'DFUモードに入りますか？',
    updateconfirm: 'DFUモードに入りました。DFUアップグレードページを開きますか？',
    updatetitle: 'DFUモードが受け付けられました'
  },
  oldfirm: {
    title: 'アップグレードの注意',
    message: 'デバイスのファームウェアバージョンが低すぎます。アップロード機能を使用する前に、最新バージョンへ更新してください。'
  },
  newfolder: {
    title: '新しいフォルダ',
    message: 'フォルダ名を入力してください',
    newfoldererr: 'フォルダの作成に失敗しました:'
  },
  rename: {
    title: '名前変更',
    message: '新しいファイル名を入力してください: ',
    errrename: '名前の変更に失敗しました: ',
    nametoolong: 'ファイルパスの最大長は63バイトです',
    pathtoolong: 'ファイル名の最大長は47バイトです'
  },
  drive: {
    message: '(ディスクを使用できません [エラーコード: ',
    messageend: '])'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/ja_JP.js